import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import Layout from "./Components/Layout";
import Projects from "./Components/Projects";
import Quotes from "./Components/Quotes";
import Weatherman from "./Components/Weatherman";
import ErrorPage from './Components/ErrorPage'
import MovieDB from "./Components/MovieDatabase/MovieDB";
import TextUtils from "./Components/TextUtils";
import About from "./Components/About";
import UsesByGRohit from "./Components/UsesByGRohit";
import Contact from "./Components/Contact";

function App() {
  return (
    <>
      <Router>
        <Routes>
          {/* Main Layout */}
          <Route index Component={Layout} />
          {/* All routings */}
          <Route exact path="/about" Component={About} />
          <Route exact path="/uses-by-grohit" Component={UsesByGRohit} />
          <Route exact path="/projects" Component={Projects} />
          <Route exact path="/contact" Component={Contact} />
          {/* Projects routing */}
          <Route exact path="/projects/weatherManApp" Component={Weatherman} />
          <Route exact path="/projects/read-a-quote" Component={Quotes} />
          <Route exact path="/projects/MovieDataBase" Component={MovieDB} />
          <Route exact path="/projects/TextUtilities" Component={TextUtils} />
          {/* Error Page */}
          <Route path="*" Component={ErrorPage} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
